import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

import Autoplay from "embla-carousel-autoplay";
import { useState } from "react";

import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS } from "@/lib/site";


export default function TestimonialsSection() {
  const [autoplayPlugin] = useState(() =>
    Autoplay({
      delay: 5500,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    })
  );

  return (
    
          <section data-testid="testimonials-section" className="relative py-24 md:py-36 bg-charcoal text-white overflow-hidden">
            <div className="grain absolute inset-0" />
            <div className="absolute -top-40 right-0 w-[500px] h-[500px] rounded-full bg-stenzia-green/10 blur-3xl" />
            <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-stenzia-gold/5 blur-3xl" />
    
            <div className="relative max-w-7xl mx-auto px-6 md:px-12">
              <Reveal>
                <div className="overline text-stenzia-gold"><span className="kbd-line" /> Customer Stories</div>
                <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.02] max-w-3xl">
                  What our clients say<br /><span className="italic text-stenzia-gold">after the install.</span>
                </h2>
              </Reveal>
    
              <Carousel
                data-testid="testimonials-carousel"
                className="mt-16"
                plugins={[autoplayPlugin]}
                opts={{ align: "start", loop: true }}
              >
                <CarouselContent>
                  {TESTIMONIALS.concat(TESTIMONIALS).map((t, i) => (
                    <CarouselItem key={i} className="md:basis-1/2 lg:basis-1/2">
                      <div className="h-full p-8 md:p-12 rounded-3xl bg-white/[0.04] border border-white/10 backdrop-blur-xl hover:bg-white/[0.07] hover:border-stenzia-gold/30 transition-all duration-500">
                        <div className="text-stenzia-gold font-display text-7xl leading-none font-light">&ldquo;</div>
                        <p className="mt-2 text-lg md:text-xl text-white/85 leading-relaxed font-light italic">{t.quote}</p>
                        <div className="mt-10 pt-6 border-t border-white/10 flex items-center gap-4">
                          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-stenzia-green to-stenzia-green-light flex items-center justify-center font-display text-white text-lg">{t.name.charAt(0)}</div>
                          <div>
                            <div className="font-display text-base text-white tracking-tight">{t.name}</div>
                            <div className="text-xs text-white/55 mt-0.5">{t.role} · {t.location}</div>
                          </div>
                        </div>
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <div className="mt-10 flex items-center gap-3">
                  <CarouselPrevious data-testid="testimonials-prev" className="relative static translate-y-0 bg-white/10 border-white/20 text-white hover:bg-stenzia-gold hover:text-charcoal hover:border-stenzia-gold transition-all w-12 h-12" />
                  <CarouselNext data-testid="testimonials-next" className="relative static translate-y-0 bg-white/10 border-white/20 text-white hover:bg-stenzia-gold hover:text-charcoal hover:border-stenzia-gold transition-all w-12 h-12" />
                  <div className="ml-auto text-xs text-white/40 tracking-widest uppercase">Auto-rotating</div>
                </div>
              </Carousel>
            </div>
          </section>
  );
}